import request from '../../products/services/requesters/product.request';
import { RegionProductType } from '../models';

const regionProductTypeService = {
  getRegionProductTypes: (query: any) =>
    request.get<RegionProductType[]>('/region-product-types', {
      params: query
    }),
  createRegionProductType: (data: any) =>
    request.post<RegionProductType[]>('/region-product-types', data)
};

export default regionProductTypeService;
